import { render } from "./RiProdcategory09.vue?vue&type=template&id=07eb4c2b"
import script from "./RiProdcategory09.vue?vue&type=script&lang=js"
export * from "./RiProdcategory09.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory09.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07eb4c2b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07eb4c2b', __exports__)) {
    api.reload('07eb4c2b', __exports__)
  }
  
  module.hot.accept("./RiProdcategory09.vue?vue&type=template&id=07eb4c2b", () => {
    api.rerender('07eb4c2b', render)
  })

}


export default __exports__